import IKnowSequencer from 'es6/controllers/apps/iknow-sequencer';
import { ResultTypes } from 'es6/models/quiz-result';
import { pause, pauseEvents } from 'es6/services/pause';

const TIMEOUTS_BEFORE_PAUSE = 2;

/*
 * Sequencer identical to the IKnowSequencer, but which auto-pauses
 * following multiple TimeoutResults.
 */
export default class RapidChoiceSequencer extends IKnowSequencer {
  constructor(...args) {
    super(...args);
    this.timeoutsRemaining = TIMEOUTS_BEFORE_PAUSE;
  }

  /*
   * @Override
   * Check if the result was a timeout and pause if necessary, before
   * deferring to the super classes normal behaviour.
   */
  quizFinished(quiz) {
    if (quiz.result.leQuizResult === ResultTypes.TIMEOUT) {
      this.timeoutsRemaining--;
    } else {
      this.timeoutsRemaining = TIMEOUTS_BEFORE_PAUSE;
    }

    if (this.timeoutsRemaining === 0) {
      this.timeoutsRemaining = TIMEOUTS_BEFORE_PAUSE;

      // Wait until after the pause before proceeding to next quiz.
      const onResume = () => {
        super.quizFinished(quiz);
        pauseEvents.removeListener('resume', onResume);
      };
      pauseEvents.on('resume', onResume);

      pause();
    } else {
      super.quizFinished(quiz);
    }
  }
}
